import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './SrOnly.css';

const SrOnly = ({ children, as: As = 'span' }) => {
  return <As className={s.srOnly}>{children}</As>;
};

export default withStyles(s)(SrOnly);
